<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false">
    <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronLeftIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>
